import { atom } from "jotai"

export const planApplicationAtom = atom<{ planId: number } | null>(null)
